module.exports = __webpack_public_path__ + "962a3fdb8a5b0c33cb3fe233ad32e650.png";